<div class="ac-location-switcher">
    <div ngbDropdown placement="bottom-right" class="d-inline-block" autoClose="true"
        #locationListDropdown="ngbDropdown">
        <button class="btn btn-outline-primary text-white ac-layerlist-toggle d-flex justify-content-between"
            ngbDropdownToggle>
            <div class="text-truncate"> {{ HsLanguageService.getTranslationIgnoreNonExisting("MAPOVERLAY.LOCATIONS",
                StrategyCommonService.selectedLocation ) }}</div>
        </button>
        <div ngbDropdownMenu class="p-3">
            <div *ngFor="let location of StrategyCommonService.dataBbox;let i = index"
                class="mapoverlay-dropdown-item flex-column">
                <div class="w-100 d-flex my-2 align-items-center">
                    <input type="radio" class="mr-3"
                        [checked]="StrategyCommonService.selectedLocation == location.location"
                        (change)="locationSelected(location);locationListDropdown.close()" id="aclocation-{{i}}"
                        name="aclocation-{{i}}">
                    <label class="m-0 text-truncate" style="max-width: 15ch;" for="aclocation-{{i}}"
                        [title]='HsLanguageService.getTranslationIgnoreNonExisting("MAPOVERLAY.LOCATIONS", location.location )'>{{
                        HsLanguageService.getTranslationIgnoreNonExisting("MAPOVERLAY.LOCATIONS", location.location )
                        }}</label>
                </div>
                <div class="dropdown-divider w-100"></div>
            </div>
        </div>
    </div>
</div>